import { useTranslation } from 'react-i18next'
import { ConfirmDialogProps } from './props.js'
import { Dialog } from './Dialog.js'
import { Button } from './Button.js'

export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  destructive = false,
  onConfirm,
  onCancel,
  loading = false,
}: ConfirmDialogProps) {
  const { t } = useTranslation()
  const resolvedConfirmLabel = confirmLabel ?? t('common.confirm')
  const resolvedCancelLabel = cancelLabel ?? t('common.cancel')
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      title={title}
      dismissible={!loading}
    >
      <p className="text-body-md text-on-surface-variant mb-6">
        {message}
      </p>
      <div className="flex gap-3 justify-end">
        <Button
          variant="outlined"
          onClick={onCancel}
          disabled={loading}
        >
          {resolvedCancelLabel}
        </Button>
        <Button
          variant={destructive ? 'danger' : 'filled'}
          onClick={onConfirm}
          loading={loading}
        >
          {resolvedConfirmLabel}
        </Button>
      </div>
    </Dialog>
  )
}
